import styles from './style.module.css';
import { BsDot } from "react-icons/bs";
import { Link, a } from 'react-router-dom';


const FooterSection = () => {
    const current_year = new Date().getFullYear()
    return (
        <div className={styles.footer_area}>
            <div className={styles.footer_area__body}>
                <div className={styles.footer_area__body__contacts}>
                    <ul>
                        <li> 107014, г. Москва, ул. Стромынка, д. 10, стр. 1</li>
                        <li> Телефон:  8-916-972-37-76 <br /> 8-499-268-00-05</li>
                        <li> e-mail: mof_2013@mail.ru</li>
                    </ul>
                </div>
                <div className={styles.footer_area__body__menu}>
                    <ul>
                        <a href="#schools"><li><BsDot /> Школа московского фтизиатра</li></a>
                        <a target="_blank" href="http://tb-journal.ru/"><li><BsDot /> Научно-практический журнал</li></a>
                        <a href="#bulletins"><li><BsDot /> Информационный бюллетень</li></a>
                        <Link to="/news/"><li><BsDot /> Новости</li></Link>
                        <Link to="/documents"><li><BsDot /> Документы</li></Link>
                        <Link to="/conferences"><li><BsDot /> Отчеты о конференциях</li></Link>
                        <Link to='/management/'><li><BsDot /> Состав Правления</li></Link>
                        <Link to="/news"><li><BsDot /> Новости</li></Link>
                    </ul>
                </div>
            </div>
            <hr />
            <div className={styles.footer_area__footer}>
                МЕЖРЕГИОНАЛЬНАЯ ОБЩЕСТВЕННАЯ ОРГАНИЗАЦИЯ "МОСКОВСКОЕ ОБЩЕСТВО ФТИЗИАТРОВ" 2013-{current_year}
            </div>
        </div>
    );
}

export default FooterSection;